export default "__VITE_ASSET__yoDGwirA__"